import { Button, Modal } from '@citizen-walk/shared-ui';
import { PHOTO_NOTICE_TEXT } from '../onboarding';

/**
 * 写真撮影前注意喚起モーダル (REQ-4.1.11、REQ-8.5.1)。
 *
 * old2 `apps/user/src/components/PhotoNoticeModal.tsx` + `locales/ja/legal.json#photoNotice` を逐語移植。
 * 本文 const は Phase A で移植済の `features/onboarding/legalText.ts#PHOTO_NOTICE_TEXT`
 * (old2 legal.json#photoNotice 逐語) を唯一の真実の源とし、本 modal はその表示に専念する。
 *
 * Phase E (old2 投稿フロー移植):
 *   - 確定ボタンを old2 通り `✓ 了解しました - 続ける` に (acknowledge + ' - ' + continue)。
 *   - 撮影前の確認として表示 (PostForm の写真選択時に未了承なら開く、old2 PostTab L238-244)。
 */

/**
 * 写真撮影注意の本文 const (後方互換 export)。`PHOTO_NOTICE_TEXT` (old2 legal.json 逐語) を素通し。
 * acknowledge は old2 PhotoNoticeModal L33 と同じく「了解しました - 続ける」を結合した文字列。
 */
export const PHOTO_NOTICE = {
  title: PHOTO_NOTICE_TEXT.title,
  intro: PHOTO_NOTICE_TEXT.intro,
  items: PHOTO_NOTICE_TEXT.items,
  afterShoot: PHOTO_NOTICE_TEXT.afterShoot,
  moderation: PHOTO_NOTICE_TEXT.moderation,
  autoBlur: PHOTO_NOTICE_TEXT.autoBlur,
  acknowledge: `${PHOTO_NOTICE_TEXT.acknowledge} - ${PHOTO_NOTICE_TEXT.continue}`,
  cancel: 'キャンセル',
} as const;

/**
 * 写真撮影注意の本文ブロック (Modal 内 / Onboarding inline 共通)。
 * Sprint U: OnboardingPage で同一本文を expand 表示するため再利用。
 */
export function PhotoNoticeBody() {
  return (
    <>
      <p className="mb-3 text-slate-800">{PHOTO_NOTICE.intro}</p>
      <ul className="list-disc list-inside mb-4 space-y-1 text-slate-900">
        {PHOTO_NOTICE.items.map((it) => (
          <li key={it}>{it}</li>
        ))}
      </ul>
      <p className="mb-2 text-slate-700">{PHOTO_NOTICE.afterShoot}</p>
      <p className="mb-2 text-sm text-slate-600">{PHOTO_NOTICE.autoBlur}</p>
      <p className="text-sm text-warning-700">{PHOTO_NOTICE.moderation}</p>
    </>
  );
}

export interface PhotoNoticeModalProps {
  open: boolean;
  onAcknowledge: () => void;
  onCancel: () => void;
}

export function PhotoNoticeModal({ open, onAcknowledge, onCancel }: PhotoNoticeModalProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={`📸 ${PHOTO_NOTICE.title}`}
      size="md"
      // 重要な同意系のため overlay click 誤閉じを防止
      closeOnOverlayClick={false}
    >
      <div className="mb-6">
        <PhotoNoticeBody />
      </div>

      <div className="flex flex-col gap-2">
        <Button variant="primary" size="md" onClick={onAcknowledge} className="w-full">
          ✓ {PHOTO_NOTICE.acknowledge}
        </Button>
        <Button variant="secondary" size="md" onClick={onCancel} className="w-full">
          {PHOTO_NOTICE.cancel}
        </Button>
      </div>
    </Modal>
  );
}
